import { render, staticRenderFns } from "./DailyGoal.vue?vue&type=template&id=ec2d580a&scoped=true&"
import script from "./DailyGoal.vue?vue&type=script&lang=js&"
export * from "./DailyGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2d580a",
  null
  
)

export default component.exports